<template>
  <div class="hotel-order" v-loading="loading">
    <div class="order-list clear">
      <div class="order-list-head font-15">乘客信息</div>
      <div class="order-list-info">
        <div class="order-user-info">
          <table class="table" width="90%">
            <tr>
              <th>票号</th>
              <th>订单号/PNR</th>
              <th>乘客姓名</th>
              <th>出票日期</th>
              <th>航班号/行程</th>
              <th>航班日期</th>
            </tr>
            <tr v-for="(detail,sindex) in detailList.list" :key="sindex">
              <td>
                <span>{{detail.ticketNumber}}</span>
              </td>
              <td>
                <span>{{detail.orderNo}}</span>
                <span>{{detail.pnr}}</span>
              </td>
              <td>{{ detail.psgName}}</td>
              <td>{{detail.ticketTime}}</td>
              <td>
                <div v-for="(flight,flightNoIndex) in detail.segmentList" :key="flightNoIndex">
                  <p>{{flight.depCityName + flight.depCityCode}} - {{flight.arrCityName + flight.arrCityCode}}</p>
                  <p>{{flight.flightNo}}</p>
                </div>
              </td>
              <td>
                <div v-for="(beginDate,beginDateIndex) in detail.segmentList" :key="beginDateIndex">
                  <p>{{beginDate.segmentTime}}</p>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="order-list clear">
      <div class="order-list-head font-15">配送信息</div>
      <div class="info-list">
        <div class="info-item">
          <span>行程单类型:</span>
          <div class="radio_box">
            <el-radio-group v-model="formData.itineraryType" @change="cost">
              <el-radio :label="1">普通行程单</el-radio>
              <el-radio :label="2">中性行程单</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="info-item">
          <span>配送方式:</span>
          <span>邮寄</span>
        </div>
        <div class="info-item">
          <span>邮寄方式:</span>
          <div class="radio_box">
            <el-radio-group
              v-model="formData.mailingID"
              size="small"
              @change="selectExpressage(formData.mailingID)"
            >
              <div v-for="(item,index) in logisticsList" :key="index">
                <el-radio :label="item.id">
                  {{item.type}}:
                  <span class="radio_num">{{item.express}}元</span>
                  <span>{{item.description}}</span>
                </el-radio>
              </div>
            </el-radio-group>
            <span class="hint">温馨提示：港澳台地区请联系客服申请</span>
          </div>
        </div>
        <div class="info-item">
          <span>邮寄地址:</span>
          <div>
            <el-form
              label-width="90px"
              :model="formData"
              label-position="right"
              :rules="rules"
              ref="userForm"
            >
              <el-form-item label="收件人:" prop="addressee">
                <el-input v-model="formData.addressee" maxlength="10"></el-input>
              </el-form-item>
              <el-form-item label="地区:" prop="areaCitys">
                <el-col :span="8">
                  <el-select v-model="formData.areaRegions" placeholder="请选择大区" @change="_getArea">
                    <el-option
                      v-for="item in siteList.area"
                      :key="item.id"
                      :label="item.areaName"
                      :value="[item.id,item.areaName]"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8" style="padding:0 10px;">
                  <el-select
                    v-model="formData.areaProvinces"
                    placeholder="请选择省份"
                    @change="_getProvince"
                  >
                    <el-option
                      v-for="item in siteList.province"
                      :key="item.id"
                      :label="item.areaName"
                      :value="[item.id,item.areaName]"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select v-model="formData.areaCitys" placeholder="请选择城市">
                    <el-option
                      v-for="item in siteList.city"
                      :key="item.id"
                      :label="item.areaName"
                      :value="[item.id,item.areaName]"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item label="街道地址:" prop="street">
                <el-input v-model="formData.street"></el-input>
              </el-form-item>
              <el-form-item label="邮政编码:">
                <el-input v-model="formData.postalCode"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="phone">
                <el-input v-model="formData.phone"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="order-list clear">
      <div class="order-list-head font-15">服务信息</div>
      <ul>
        <li>1、提交退票时需将行程单退回原打印服务点。</li>
        <li>2、退废票时行程单打印费用和邮寄费用不予退回。</li>
        <li>3、中性行程单统一收取打印费用为3.5元/张，普通行程单不收取打印费用。</li>
        <li>
          4、
          <span @click="dialogVisible = true" style="color:#237dc8;cursor:pointer">《行程单申请须知》</span>
        </li>
      </ul>
    </div>
    <div class="order-list clear">
      <div class="order-list-head font-15">
        费用明细
        <span
          style="color:#237dc8;font-size:13px;padding:0 50px;"
          v-if="costShow"
        >总费用({{totalFeeList.total}}) = 行程单打印费用({{totalFeeList.printFee}}) + 快递费用({{totalFeeList.mailingFee}})</span>
      </div>
      <table class="table" width="90%">
        <tr>
          <td>总费用：</td>
          <td @mousemove="costShow = true" @mouseout="costShow = false">
            <span class="money-ico">¥{{totalFeeList.total}}</span>
          </td>
          <td>行程单打印费用：</td>
          <td>
            <span class="money-ico">¥{{totalFeeList.printFee}}</span>
          </td>
          <td>快递费用：</td>
          <td>
            <span class="money-ico">¥{{totalFeeList.mailingFee}}</span>
          </td>
        </tr>
      </table>
    </div>
    <!-- <div class="order-list clear">
            <div class="order-list-head font-15">支付方式</div>
            <div style="padding:20px;">
                <el-radio>易宝支付</el-radio>
            </div>
    </div>-->
    <!-- <div class="order-list clear">
            <div class="submit-btn">
                <div class="submit-btn-text">
                    <div>
                    <p class="text-money">待支付: <span class="font-12">¥</span> <span>{{detailList.totalFee}}</span></p>
                    <p>  <el-checkbox v-model="affirmStatu">我已阅读以上服务细则</el-checkbox></p>
                    </div>
                    <div class="btn cursor" @click="submit">
                        支付
                    </div>
                </div>
            </div>
    </div>-->
    <pay-menthod ref="payComponent" situation="000"></pay-menthod>
    <el-dialog title="行程单申请须知" :visible.sync="dialogVisible" width="800px">
      <div class="dialog-text">
        <p>1.在平台上申领的行程单只适用于平台上采购的电子客票，作为旅客购买客票的发票一人一票。</p>
        <p>2.邮寄费按所选相应快递公司计费。</p>
        <p>3.不支持“特殊政策”订单行程单打印服务。</p>
        <p>4.行程单打印时效为：“航班起飞日期（含）15内可申请打印，超过15日后平台无法提供打印服务”。( 行程单能否打印，需要以中航信系统显示为准)</p>
        <p>5.当日支付订单建议次日选择打印行程单，以免影响当日废票。</p>
        <p>6.客票作废时，若行程单已取、己寄出，须在行程单供应商工作时间内将行程单送回。否则按照自愿退票处理。</p>
        <p>7.客票退票时，须将行程单邮寄回取单地后，才可申请退票。</p>
        <p>8.己打印的行程单退废票时，行程单服务费和邮寄费不予退还。</p>
        <p>9.凡申请“自取”行程单服务的，请在申请后的一周内将行程单取走，超时供应商不负责保管。</p>
        <p>10.凡申请“保存邮寄”行程单服务的，请在申请后的一月内支付邮寄费用，超时不负责保管,邮寄一次性限制100张以内。</p>
        <p>
          11.采购商在退废票时因行程单丢失或损毁无法将行程单交回，须向平台传真
          <a
            class="text-warning"
            href="https://yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/temp/invoice_lose.doc
"
            download="航空运输电子客票行程单"
          >《航空运输电子客票行程单遗失声明》</a>
          ,平台将按50元/张收取罚金，在客票的退票款中扣除。
        </p>
        <p>12.为了给您提供更优质的服务，请提前2天提交行程单自取和邮寄需求。</p>
        <div class="dialog-bar">平台拥有对以上采购须知条款解释权</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import itineraryLogistics from "@/lib/data-service/flight/flight_domestic_buyer_manage_order_itinerary_logistics";
import itineraryParams from "@/lib/data-service/flight/flight_domestic_buyer_manage_order_itinerary_params";
import itineraryApply from "@/lib/data-service/flight/flight_domestic_buyer_manage_order_itinerary_apply";
import itineraryPay from "@/lib/data-service/flight/flight_domestic_buyer_pay";
import getInlandAreaChildListByParentIdResponse from "@/lib/data-service/default/web_common_area_getInlandAreaChildListByParentIdResponse";
import payment from "@/lib/data-service/flight/newFligthApi/payment_params";
import PayMenthod from "@/lib/common-service/getPayModule";

import ItineraryTotal from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_itinerary_total";
import itineraryUpdate from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_itinerary_update";

import saveDetail from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_itinerary_save_detail";
export default {
  name: "hotelOrder",
  data() {
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      if (!Number.isInteger(+value)) {
        callback(new Error("请输入数字值"));
      } else {
        if (phoneReg.test(value)) {
          callback();
        } else {
          callback(new Error("电话号码格式不正确"));
        }
      }
    };
    return {
      formData: {
        currentPage: 1,
        pageSize: 10,
        psgNoList: "",
        itineraryType: 1,
        mailingID: 1
      },
      dialogVisible: false,
      totalFeeList: {},
      loading: true,
      orderStatu: 0,
      costShow: false,
      affirmStatu: false,
      expressageCost: 0,
      orderNo: "",
      logisticsList: [],
      inputInfo: {},
      detailList: {
        totalFee: 0
      },
      mailInfo: null,
      siteList: {},
      rules: {
        addressee: { required: true, message: "请输入收件人", trigger: "blur" },
        areaCitys: { required: true, message: "请选择城市", trigger: "blur" },
        street: { required: true, message: "请输入街道信息", trigger: "blur" },
        phone: { validator: checkPhone, trigger: "blur", required: true }
      },
      detailInfo: {},
      addStatu: 0
    };
  },
  components: { PayMenthod },
  async created() {
    // let psgNo = this.$route.query.psgNo;

    // let psgNoAll = this.$route.query.psgNoAll;
    // let ticketNumberList = this.$route.query.ticketNumberList;
    // this.orderNo = this.$route.query.orderNo;
    // psgNo
    //   ? ((this.formData.psgNoList = [psgNo]),
    //     (this.formData.ticketNumList = ticketNumberList.split(",")))
    //   : "";
    // psgNoAll
    //   ? ((this.formData.psgNoList = psgNoAll.split(",")),
    //     (this.formData.ticketNumList = ticketNumberList.split(",")))
    //   : "";
    let dataInfo = this.$route.query.dataInfo;
    dataInfo ? (this.formData.passengerVOList = JSON.parse(dataInfo)) : "";
    let res = await this.getInfo();
    this.getLogistics();
    this._getInlandArea("100000", res => {
      this.$set(this.siteList, "area", res);
    });
    this.$nextTick(() => {
      this.payInit();
    });
  },
  watch: {},
  computed: {},
  methods: {
    payInit() {
      let orderInfo;
      let __this = this;
      orderInfo = payment({ type: 14 });
      orderInfo.then(res => {
        this.$refs.payComponent.init({
          // get_order_data() {
          //   const order_data = {
          //     companyId: res.companyId,
          //     clubId: res.clubId,
          //     orderNo: __this.detailList.list[0].orderNo,
          //     businessContent: res.businessContent,
          //     subject: "国内机票行程单支付",
          //     orderAmount: Number(__this.totalFeeList.total),
          //   };
          //   return order_data;
          // },
          situationParameter: {
            "000": {
              companyId: res.companyId,
              clubId: res.clubId,
              orderNo: __this.detailInfo.itineraryNo,
              businessContent: res.businessContent,
              subject: "国内机票行程单支付",
              orderAmount: Number(__this.totalFeeList.total),
              // pay_remaining_seconds:1200
              count_down: {
                enable: false
              }
            }
          },
          async before_pay_event_handler() {
            let statu;
            statu = await __this.submit();
            // .then(res => {
            //   if (res.code == "000000") {
            //     __this.addStatu = 1;
            //     return true;
            //   }
            // })
            // .catch(() => {
            //   return false;
            // });
            if (statu.code === "000000") {
              __this.addStatu = 1;
              return Promise.resolve("success");
            } else {
              return Promise.reject("error");
            }
          },
          //支付成功事件处理方法
          pay_successful_event_handler() {
            // __this.submit().then(res => {
            //   if (res.code == "000000") {
            //     __this.addStatu = 1;
            //   }
            itineraryUpdate({
              itineraryNo: __this.detailInfo.itineraryNo,
              status: __this.addStatu
            }).then(res => {
              __this.$router.go(-1);
            });
            // __this.submit().then(res => {
            //   __this.$router.go(-1);
            // });
            __this.$message({ type: "success", message: "支付成功！" });
          },
          //支付失败事件处理方法
          pay_failed_event_handler() {
            __this.$message({
              type: "warning",
              message: "支付失败，请重新支付！"
            });
          }
        });
      });
    },
    cost() {
      let data = {
        itineraryType: this.formData.itineraryType,
        mailingId: this.expressageCost.id,
        psgCount: this.detailList.list.length
      };
      ItineraryTotal(data).then(res => {
        console.log(res);
        this.totalFeeList = res.result;
        this.payInit();
      });
    },
    getInfo() {
      let data = Object.assign({}, this.formData);
      let obj = {};
      if (data.passengerVOList instanceof Array) {
        obj.ticketNumList = data.passengerVOList.map(item => {
          return item.ticketNumber;
        });
        obj.psgNoList = data.passengerVOList.map(item => {
          return item.psgNo;
        });
      } else {
        obj.ticketNumList = [data.passengerVOList.ticketNumber];
        obj.psgNoList = [data.passengerVOList.psgNo];
      }
      return itineraryParams(obj).then(res => {
        this.loading = false;
        this.detailInfo = res;
        this.detailList.list = res.result;
        this.$forceUpdate();
      });
    },
    selectExpressage(val) {
      let list = this.logisticsList.filter(item => {
        return item.id == val;
      });
      this.expressageCost = list[0];
      console.log(list);
      this.mailInfo = list;
      this.cost();
    },
    getLogistics() {
      itineraryLogistics().then(res => {
        this.logisticsList = res.result;
        this.expressageCost = res.result[0];
        this.formData.mailingID = this.expressageCost.id;
        this.cost();
      });
    },
    _getInlandArea(id, callback) {
      getInlandAreaChildListByParentIdResponse({ id: id }).then(res => {
        callback(res.areaTreeResult);
      });
    },
    _getArea(val) {
      this._getInlandArea(val[0], res => {
        this.formData.areaProvinces ? (this.formData.areaProvinces = "") : "";
        this.formData.areaCitys ? (this.formData.areaCitys = "") : "";
        this.$set(this.siteList, "province", res);
      });
    },
    _getProvince(val) {
      this._getInlandArea(val[0], res => {
        this.formData.areaCitys ? (this.formData.areaCitys = "") : "";
        this.$nextTick(() => {
          this.$set(this.siteList, "city", res);
        });
      });
    },
    submit() {
      let data = this.formData;
      data.distributionType = "邮寄";
      data.areaCitys
        ? (data.address =
            data.areaRegions[1] + data.areaProvinces[1] + data.areaCitys[1])
        : "";
      // console.log(this.formData)
      let form = {},
        status;
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          // if (!data.mailingID)
          //   return this.$message({
          //     type: "warning",
          //     message: "请选择邮寄方式"
          //   });
          // if (!this.affirmStatu)
          //   return this.$message({
          //     type: "warning",
          //     message: "请勾选服务细则"
          //   });
          form = {
            address: data.address,
            addressee: data.addressee,
            amount: 0,
            distributionType: data.distributionType,
            mailingName: this.mailInfo
              ? this.mailInfo[0].type
              : this.logisticsList[0].type,
            payAmount: this.totalFeeList.total,
            itineraryNo: this.detailInfo.itineraryNo,
            phone: data.phone,
            postalCode: data.postalCode,
            psgNoList: data.psgNoList,
            itineraryType: data.itineraryType,
            street: data.street,
            passengerVOList:
              data.passengerVOList instanceof Array
                ? data.passengerVOList
                : [data.passengerVOList]
            // street: 1,
            // printFee: Number(__this.totalFeeList.total)
          };
          this.inputInfo = form;
          status = true;
          // itineraryApply(data).then(res => {
          //   let list = {
          //     orderNo: res.itineraryOrderNo,
          //     paymentChannel: "YEEPAY",
          //     paymentType: 13,
          //     totalFee: res.amount
          //   };
          //   this.payment(list);
          // });
        } else {
          status = false;
        }
      });
      if (status) {
        return saveDetail(form);
      } else {
        return Promise.reject("请完善信息！");
      }
    }
    // payment(val) {
    //   itineraryPay(val).then(res => {
    //     window.open(res.htmlStr);
    //   });
    // }
  }
};
</script>
<style lang="less" scoped>
.hotel-order {
  // display: flex;
  color: #4b4b4b;
  .order-list {
    &:nth-child(2n) {
      margin: 10px 0;
    }
    border: solid 1px #dfdfdf;
    .order-list-head {
      background: #ecf6ff;
      padding: 12px 20px;
      position: relative;
      &::after {
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        content: "";
        height: 100%;
        width: 8px;
        background: #237dc8;
      }
    }
    ul {
      padding: 20px 40px;
      li {
        list-style: none;
        padding: 5px 0;
        font-size: 14px;
      }
    }
    .text-area {
      padding: 10px;
    }
  }
  .order-list-box {
    padding: 30px;
    .order-list-info {
      font-size: 16px;
      padding: 10px;
      display: flex;
      align-items: center;
      .order-list-info-input {
        width: 100px;
      }
      .list-info-cause {
        width: 80%;
      }
      .order-list-info-text {
        width: 80%;
        margin: auto;
      }
      .room-warn {
        font-size: 10px;
        color: #b2b2b2;
        font-style: normal;
      }
      span:nth-child(1) {
        display: inline-block;
        text-align: end;
        width: 120px;
      }
      span:nth-child(2) {
        display: inline-block;
        color: #237dc8;
      }
      .order-day-num {
        margin-left: 20px;
        i {
          font-size: 15px;
          padding: 0 5px;
          font-style: normal;
        }
      }
    }
  }
  .order-add-user {
    display: inline-block;
    padding-left: 5px;
    font-size: 15px;
  }
  .form-box {
    width: 80%;
    margin: auto;
    .form-user {
      width: 400px;
      margin: 23px 0 0 0;
      font-size: 14px;
      .form-title {
        padding-left: 100px;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: normal;
        letter-spacing: 1px;
        color: #4b4b4b;
        font-stretch: normal;
        font-family: MyriadPro-Regular;
      }
    }
  }
  .order-user-info {
    .notice-text {
      width: 90%;
      margin: auto;
      font-size: 14px;
      color: #8c8c8c;
      padding-top: 10px;
    }
  }
  .colse-account {
    width: 25%;
    margin: 10px 20px;
    .colse-account-content {
      min-height: 100px;
      border: solid 1px #b2b2b2;
    }
    .colse-accound-head {
      background: #237dc8;
      color: white;
      font-size: 16px;
      padding: 12px 20px;
    }
    .colse-accound-img {
      height: 165px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .colse-accound-box {
      padding: 17px 25px;
      font-size: 10px;
      color: #7b7b7b;
      p {
        padding: 3px 0;
      }
      .title {
        color: #237dc8;
        font-size: 18px;
        font-weight: bold;
      }
      .title-english {
        color: #237dc8;
        font-size: 12px;
      }
      .hose {
        color: #237dc8;
        font-size: 16px;
        padding: 18px 0 10px 0;
      }
    }
    .colse-accound-money {
      background: #fafafa;
      padding: 10px 0;
      p:nth-child(1) {
        font-size: 18px;
        color: #666;
        font-weight: bold;
        text-align: end;
        padding: 10px;
        span {
          font-size: 16px;
          font-weight: 400;
          color: #ff6600;
        }
        border-bottom: 1px dashed #b2b2b2;
      }
      p:nth-child(2) {
        font-size: 14px;
        color: #666;
        padding: 10px;
        text-align: end;
      }
      .btn {
        height: 37px;
        background: #ff6600;
        color: white;
        font-size: 17px;
        width: 159px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .roomRate {
    border: 1px solid #ccc;
    color: #8c8c8c;
    font-size: 12px;
    text-align: center;
    // &:nth-child(2n){
    //     border-right: 0;
    // }
    .roomRateItem {
      .room-title {
        background: #ecf6ff;
        padding: 3px 10px;
      }
      .room-rate-money {
        padding: 8px 15px;
        p:nth-child(1) {
          font-size: 16px;
          color: #ff6600;
          padding-bottom: 1px;
          i {
            font-style: normal;
            padding-right: 5px;
          }
        }
      }
    }
  }
  /deep/.el-input {
    height: 30px;
    input {
      height: 30px;
      border-radius: 0;
    }
  }
  .el-input-number {
    line-height: 28px;
  }

  .el-input__inner {
    border-radius: 0;
    padding: 0;
    height: 30px;
    line-height: 30px;
  }
  /deep/.el-date-editor .el-range__icon {
    line-height: 25px;
    margin-left: 0;
  }
  /deep/.el-range-separator {
    line-height: 28px;
  }
  /deep/.el-select__caret {
    line-height: 0;
  }
  /deep/.el-icon-time {
    line-height: 30px;
  }
  /deep/.el-input__suffix .el-input__icon {
    line-height: 30px;
  }
  .order-text-box {
    background: #fff4ee;
    border: 1px solid #ffc096;
    margin-bottom: 10px;
    padding: 10px 20px;
    font-size: 14px;
    color: #666;
    .title {
      color: #4c93d0;
      font-size: 18px;
    }

    .order-text-box-content {
      display: flex;
      justify-content: space-between;
    }
    .text-box-left {
      display: flex;
      margin-right: 100px;
      p {
        padding: 5px 0;
        padding-left: 30px;
      }
      img {
        width: 200px;
        height: 120px;
        border: 1px solid black;
      }
    }
    .text-box-right {
      p {
        padding: 5px 0;
        span {
          color: #ff7e2e;
          padding-right: 2px;
        }
      }
    }
    .text-box-btn {
      color: #ff7e2e;
      font-size: 18px;
    }
  }
  .submit-btn {
    padding: 20px;
    .submit-btn-text {
      font-size: 18px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .btn {
        padding: 10px 50px;
        background: #237dc8;
        color: white;
        margin-left: 30px;
        font-size: 15px;
      }
      .text-money {
        padding: 5px 0;
        span {
          color: #ff7e2e;
        }
      }
    }
  }
  .info-list {
    padding: 20px 40px;
    font-size: 14px;
    .info-item {
      display: flex;
      padding: 10px 0;
      span {
        display: inline-block;
        width: 80px;
        text-align: right;
      }
    }
    .radio_box {
      padding-left: 30px;
      width: 100%;
      display: flex;
      div:nth-child(2n) {
        padding: 10px 0;
      }
      .radio_num {
        color: #ff7e2e;
        padding: 0 10px;
      }
    }
  }
}
.money-ico {
  padding: 0 5px;
  font-size: 10px;
  color: #ff7e2e;
}
.table {
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border-collapse: collapse;
  th {
    font-size: 13px;
  }
  td {
    text-align: center;
    font-size: 12px;
    padding: 5px 0;
  }
}
table td,
table th {
  border: 1px solid #cad9ea;
  color: #666;
  height: 30px;
}
/deep/.form-container {
  border-color: #dfdfdf !important;
  .header {
    .tag {
      border-left: #237dc8 8px solid !important;
    }
  }
  .title {
    font-size: 15px !important;
    color: #4b4b4b !important;
    padding-left: 10px !important;
  }
}
/deep/.button-container {
  padding: 35px 40px !important;
  border: 1px solid #ffb27f;
  background: #fffcfa;
  .el-button {
    background: #ff6600 !important;
    border-color: #ff6600 !important;
    border-radius: 0 !important;
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
/deep/.el-dialog {
  .el-dialog__header {
    background: #237dc8fa;
    .el-dialog__title {
      color: white;
    }
  }
}
.dialog-text {
  .text-warning {
    text-align: right;
    color: #237dc8;
  }
  p {
    padding: 5px 0;
    text-align: justify;
    line-height: 25px;
    letter-spacing: 1px;
  }
  .dialog-bar {
    font-size: 12px;
    text-align: right;
  }
}
.hint {
  font-size: 13px;
  color: red;
  width: 50% !important;
  padding: 0 10px;
}
</style>


